import React, { useEffect } from 'react';
import HedinIcon from '@hedinbil/hedin-ui/dist/icons/components/HedinIcon';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { INITIAL_CHECKOUT_DATA } from '../../Feature/hedin-checkout/actions/types';
import { connect } from 'react-redux';
import { checkoutActions } from '../../Feature/hedin-checkout/actions/checkoutActions';
import { filterActions } from '../../Feature/hedin-filters/actions/filterActions';
import PageEditorWrapper from '../../Foundation/components/PageEditorWrapper';
import { getVariantImage } from '../../Project/bavaria-no/utils/getVariantImage';
import noImage from '../../Project/bavaria-no/assets/img/truck-site-placeholder.jpg';
import RoutableSitecoreLink from '@hedinbil/hedin-ui/dist/utils/RoutableSitecoreLink';
import { LazyLoadedImage } from '@hedinbil/hedin-ui/dist/utils/components/LazyLoadedImage';
import { getAndSetCarGTMData } from '@hedinbil/hedin-ui/dist/utils/seo/getAndSetCarGTMData';
import { DefaultContactView } from './components/DefaultContactView';
import { SampleCarContactView } from './components/SampleCarContactView';
import { fallbackImagePath } from '../../Project/bavaria-no/utils/fallbackImagePath';

const sendEventToGTM = (type) => {
  const carData = getAndSetCarGTMData();

  window.dataLayer.push({
    event: type,
    url: window.location.href,
    ...carData,
  });
};

const ResellerDetail = (props) => {
  const { fields, rendering, currentCarState } = props;
  const reseller = fields?.reseller;
  const fallbackpath = fallbackImagePath(fields?.reseller?.city, true);

  useEffect(() => {
    props.checkoutActions(
      INITIAL_CHECKOUT_DATA,
      {
        name: reseller?.contactPerson?.name ? reseller?.contactPerson?.name : '',
        email: reseller?.contactPerson?.email ? reseller?.contactPerson?.email : '',
        phone: reseller?.contactPerson?.phone ? reseller?.contactPerson?.phone : '',
        siteName: reseller?.contactCompany?.name ? reseller?.contactCompany?.name : '',
      },
      'sellerDetails'
    );
    props.checkoutActions(
      INITIAL_CHECKOUT_DATA,
      {
        siteAddress: reseller?.contactCompany?.adress,
      },
      'meta'
    );
  }, []);

  return (
    <div className="bg-gray-lighter car-contact-wrapper" id="product-site">
      <div className="hero hero--low">
        <div className="hero__media">
          {fallbackpath !== null ? (
            <LazyLoadedImage src={fallbackpath} alt={reseller?.name} className="hero__image" />
          ) : (
            <img src={noImage} alt={reseller?.name} className="hero__image" />
          )}
        </div>
      </div>
      <div className="car-contact car-contact-section">
        <div className="car-contact__left">
          <div className="car-contact__content">
            <p className="car-contact__subline">
              {currentCarState?.condition === 'SAMPLE'
                ? 'VÄLKOMMEN ATT KONTAKTA OSS'
                : 'Salgsavdeling og service'}
            </p>
            <h2 className="car-contact__title">{reseller?.name}</h2>
            {currentCarState?.vehicleType === 'LB' && <h3>{currentCarState?.title}</h3>}
            {currentCarState?.vehicleType === 'LB' ? (
              <div className="h-mt-6 h-mb-2">
                <RoutableSitecoreLink
                  to="/anlaggningar"
                  className="button button--icon button--naked"
                >
                  hitta anläggning
                </RoutableSitecoreLink>
              </div>
            ) : (
              <>
                {currentCarState?.condition === 'SAMPLE' ? (
                  <SampleCarContactView carData={currentCarState} />
                ) : (
                  <DefaultContactView reseller={reseller} sendEventToGTM={sendEventToGTM} />
                )}
              </>
            )}
          </div>
          {currentCarState?.condition !== 'SAMPLE' ? (
            <div className="car-contact__sellers">
              <div className="seller seller--bordered">
                <div className="seller__content">
                  <h3 className="seller__title">{reseller?.contactPerson?.name}</h3>
                  {reseller?.contactPerson?.phone && (
                    <a
                      href={`tel:${reseller?.contactPerson?.phone}`}
                      onClick={() => sendEventToGTM('contactSeller')}
                      className="contact-link contact-link--tel d-flex"
                    >
                      <HedinIcon iconName="Phone" />
                      {reseller?.contactPerson?.phone}
                    </a>
                  )}
                  {reseller?.contactPerson?.email && (
                    <a
                      href={`mailto:${reseller?.contactPerson?.email}`}
                      onClick={() => sendEventToGTM('contactSeller')}
                      className="contact-link contact-link--mailto d-flex"
                    >
                      <HedinIcon iconName="Mail" />
                      {reseller?.contactPerson?.email}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className="car-contact__right" id="car-contact">
          <Placeholder name="jss-resellerform" rendering={rendering} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  checkoutState: state.checkout,
  currentCarState: state.filter.currentCar,
});

export default connect(mapStateToProps, { checkoutActions, filterActions })(
  PageEditorWrapper(ResellerDetail)
);
